import { Box, Modal } from "@mui/material";
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import * as yup from "yup";
import { CallV3Context } from "../state/CallV3Context";
import { ClientContext } from "../state/ClientContext";
import { getFirstName } from "../utils/fieldAccessors";

const EndCallModal = () => {
  const { callEndState, submitCallDescription, clearEndCallState } =
    useContext(CallV3Context);
  const { selectedClient } = useContext(ClientContext);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [callerName, setCallerName] = useState(null);

  useEffect(() => {
    if (callEndState === "ended") {
      setCallerName(getFirstName(selectedClient, "Client"));
      setIsOpenModal(true);
    }
  }, [callEndState, selectedClient]);

  const formik = useFormik({
    initialValues: { description: "" },
    validationSchema: yup.object({
      description: yup.string().required("Enter description."),
    }),
    onSubmit: async (values) => {
      try {
        const response = await submitCallDescription(values.description);
        if (response.ok) {
          formik.resetForm();
          setIsOpenModal(false);
          clearEndCallState();
        }
      } catch (error) {
        console.error("Error adding call history: " + error.message);
      }
    },
  });

  const handleSkip = async () => {
    try {
      const response = await submitCallDescription(undefined);
      if (response.ok) {
        formik.resetForm();
        setIsOpenModal(false);
        clearEndCallState();
      }
    } catch (error) {
      console.error("Error adding call history: " + error.message);
    }
  };

  return (
    <Modal disableEscapeKeyDown open={isOpenModal}>
      <Box
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          backgroundColor: "#d0d0d0",
          borderColor: "grey.900",
          borderWidth: "3px",
          p: 3,
          textAlign: "center",
          paddingLeft: "60px",
          paddingRight: "60px",
          color: "#000000",
        }}
      >
        <h2 style={{ paddingBottom: "20px" }}>
          How was your call{callerName ? ` with ${callerName}` : ""}?
        </h2>
        <textarea
          id="description"
          placeholder="Describe how the call went and what you discussed."
          style={{ width: "100%", height: "250px" }}
          value={formik.values.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.description && formik.errors.description && (
          <p style={{ color: "#FF0000", textAlign: "left" }}>
            {formik.errors.description}
          </p>
        )}
        <button
          className="btn-primary text-black"
          onClick={handleSkip}
          style={{ marginTop: "40px" }}
        >
          Skip for now
        </button>
        <button
          className="btn-primary text-black"
          onClick={formik.handleSubmit}
        >
          Save
        </button>
      </Box>
    </Modal>
  );
};

export default EndCallModal;
